import { Stack, Typography, useTheme } from '@mui/material';
import { LastRunIcon } from '../components/Icon';
import { FormattedMessage } from 'react-intl';
import moment from 'moment/moment';
export const LastRunInfo = (props: { date: moment.MomentInput; }) => {
  const theme = useTheme()
  return (
    <Stack direction={'row'} padding='5px' marginLeft='7px'>
      <LastRunIcon/>
      <Typography marginLeft='5px' variant={'body2'} fontWeight={theme.typography.fontWeightRegular}>
        <FormattedMessage id={'TestCheckDate'} />
      </Typography>
      <Typography marginLeft='auto' variant={'body2'} >
        &nbsp;{moment(props.date).fromNow()}
      </Typography>
    </Stack>
  )
};